import * as API from 'common/constant/routes'
import { getJson } from 'helper/http'

export const getFundingFiles = () => getJson(API.GET_FUNDING_FILES, {})
export const fundingsDownloadPDF = (file) => getJson(API.DOWNLOAD_CLUB_FUNDING, {}, { ...file })
export const constituencyDownloadPDF = (constituency, region, year, cco) => getJson(API.CONSTITUENCY_DOWNLOAD_PDF, {}, { cco, constituency, region, year })
export const getLeagueWideFunding = () => getJson(API.GET_LEAGUE_WIDE_FUNDING, {}, {})
